import React from 'react';
import { Container } from 'react-bootstrap';
import { Trans } from 'react-i18next';

const OutsourcingCost4 = props => (
    <section id="outsourcing-cost-section4" className="my pt-5 white-bg">
        <div className='black-shape'></div>
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingCost:section-4.title')}</h2>
            <p className='m-0'>
                <Trans i18nKey="services:outsourcingCost:section-4.text"
                    components={{
                        br: <br />,
                        outsourcingVsFull: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_vs_full.path')} className="link" />
                    }} />
            </p>
        </Container>
    </section>
);

export default OutsourcingCost4;
